/**
 * Betragsanzeige der Elternzeile einer Sammelsendung (Spec 29.09.2026): Betraege verschiedener
 * Waehrungen werden nie addiert, der Aufrufer kennt die Waehrung je Summe selbst (`EUR`/`USD`, aus
 * `Sammelsendung.calculatedPaymentTotals`). Dieselben Formate wie `fmtMoney0` (`lib/money.ts`), aber
 * ohne Bestellbezug - deshalb hier und nicht in `lib/money.ts`, dessen Symbole ans
 * Herkunftsdokument des Bestands gebunden sind.
 */
import { EUR0, NUM } from "../lib/format.ts";

/** Summenschluessel des Backends fuer Bestellungen, deren Waehrung nicht feststellbar ist (JTL nicht erreichbar). */
export const WAEHRUNG_UNBEKANNT = "unbekannt";

/** Ganzer Betrag in einer ausdruecklich genannten Waehrung; eine unbekannte Waehrung bekommt kein Symbol. */
export function fmtBetragInWaehrung(v: number, waehrung: string): string {
  if (waehrung === WAEHRUNG_UNBEKANNT) return NUM.format(Math.round(v)) + " (Währung unbekannt)";
  return waehrung === "USD" ? "$ " + NUM.format(Math.round(v)) : EUR0.format(v);
}

/** Eine Summe je Waehrung, nebeneinander (` · `), nie umgerechnet oder addiert; leer ohne Summen. */
export function fmtSummeJeWaehrung(
  summen: readonly { currency: string; amount: number }[],
  trenner = " · ",
): string {
  return summen.map((summe) => fmtBetragInWaehrung(summe.amount, summe.currency)).join(trenner);
}
